export default __webpack_public_path__ + "locales/sk/Common.json?hash=eedd09f71d455b0b852754940ff54a05";